/**
 * @function setFormItemRequired 设置字段必填
 * @param chapterIndex 章
 * @param sectionIndex 节
 * @param keys 选择要设置必填项的字段数组
 * @param value true/false
 */
function setFormItemRequired(chapterIndex, sectionIndex, keys, value) {
  return ["setFormItemRequired", chapterIndex, sectionIndex, keys, value];
}

/**
 * @function setFormItemDisabled 设置字段禁用
 * @param chapterIndex 章
 * @param sectionIndex 节
 * @param keys 选择要设置禁用项的字段数组
 * @param value true/false
 */
function setFormItemDisabled(chapterIndex, sectionIndex, keys, value) {
  return ["setFormItemDisabled", chapterIndex, sectionIndex, keys, value];
}

/**
 * @function setFormItemValue 设置字段值
 * @param key 字段
 * @param value 值
 * @param same 是否取当前字段自己的值
 */
function setFormItemValue(key, value, same) {
  return ["setFormItemValue", key, value, same];
}

/**
 * @function setFormItemWithCustom 自定义设置字段值
 * @param type 自定义处理的类型
 * @param args 参数数组
 *
 */
function setFormItemWithCustom(type, ...args) {
  return ["setFormItemWithCustom", type, ...args];
}

/**
 * @function houseHooks 住建专供自定义设置字段值
 * @param type 自定义处理的类型
 * @param args 参数数组
 *
 */
function houseHooks(type, ...args) {
  return ["houseHooks", type, ...args];
}

/**
 * @function trafficHooks 交通专供自定义设置字段值
 * @param type 自定义处理的类型
 * @param args 参数数组
 *
 */
function trafficHooks(type, ...args) {
  return ["trafficHooks", type, ...args];
}

const hooks = {
  setFormItemDisabled,
  setFormItemRequired,
  setFormItemValue,
  setFormItemWithCustom,
  trafficHooks,
  houseHooks
};

module.exports = {
  hooks,
};
